import { render, staticRenderFns } from "./budgetYearPlanDetailAppr.vue?vue&type=template&id=4b24522e"
import script from "./budgetYearPlanDetailAppr.vue?vue&type=script&lang=js"
export * from "./budgetYearPlanDetailAppr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b24522e')) {
      api.createRecord('4b24522e', component.options)
    } else {
      api.reload('4b24522e', component.options)
    }
    module.hot.accept("./budgetYearPlanDetailAppr.vue?vue&type=template&id=4b24522e", function () {
      api.rerender('4b24522e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/appr/sai/budget/budgetYearPlanDetailAppr.vue"
export default component.exports